module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image6-28cde681d67b1f859b3137fe369d74b8.jpg";